import { render, staticRenderFns } from "./editOpenApiApp.vue?vue&type=template&id=54ee1833"
import script from "./editOpenApiApp.vue?vue&type=script&lang=js"
export * from "./editOpenApiApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports